import { cn } from '@/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const badgeVariants = cva(
  cn('inline-flex items-center rounded-full border px-2 py-0.5 text-sm',
    'transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2'),
  {
    defaultVariants: {
      variant: 'default',
    },
    variants: {
      variant: {
        chip: 'border-transparent bg-gray-200 text-foreground',
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        destructive: 'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
      },
    },
  }
);

export type BadgeProps = {} & React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof badgeVariants>;

const Badge = ({ className, variant, ...props }: BadgeProps): React.JSX.Element => {
  return (
    <div className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
};

export { Badge, badgeVariants };
